var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 42C22 42.5304 21.7893 43.0391 21.4142 43.4142C21.0391 43.7893 20.5304 44 20 44H8C7.46957 44 6.96086 43.7893 6.58579 43.4142C6.21071 43.0391 6 42.5304 6 42V26C6 25.4696 6.21071 24.9609 6.58579 24.5858C6.96086 24.2107 7.46957 24 8 24M32 32C32 32.5304 31.7893 33.0391 31.4142 33.4142C31.0391 33.7893 30.5304 34 30 34H18C17.4696 34 16.9609 33.7893 16.5858 33.4142C16.2107 33.0391 16 32.5304 16 32V16C16 15.4696 16.2107 14.9609 16.5858 14.5858C16.9609 14.2107 17.4696 14 18 14M42 12C41.9998 10.9392 41.5782 9.92197 40.828 9.172L36.828 5.172C36.078 4.4218 35.0608 4.00023 34 4H28C27.4696 4 26.9609 4.21071 26.5858 4.58579C26.2107 4.96086 26 5.46957 26 6V22C26 22.5304 26.2107 23.0391 26.5858 23.4142C26.9609 23.7893 27.4696 24 28 24H40C40.5304 24 41.0391 23.7893 41.4142 23.4142C41.7893 23.0391 42 22.5304 42 22V12Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileStack);
export default __webpack_public_path__ + "static/media/file-stack.3e122122dc87a664efbdd87a0100e936.svg";
export { ForwardRef as ReactComponent };